'use client';

import axios, { AxiosError, AxiosResponse } from 'axios';
import { signOut } from 'next-auth/react';

import { getApiUrl } from '@/shared/utils/getApiUrl';

// Создаем кастомный axios instance
const apiClient = axios.create({
  timeout: 10000,
});

// Интерцептор для добавления токена авторизации
apiClient.interceptors.request.use(
  (config) => {
    // Токен будет добавлен в конкретных запросах через header
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Интерцептор для обработки ответов и ошибок
apiClient.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  async (error: AxiosError) => {
    // Проверяем, если получили 401 ошибку (Unauthorized)
    if (error.response?.status === 401) {
      console.warn(
        'Получена 401 ошибка - токен протух, выполняем разлогинивание',
      );

      // Разлогиниваем пользователя через NextAuth
      await signOut({
        redirect: true,
        callbackUrl: '/login',
      });
    }

    return Promise.reject(error);
  },
);

// Вспомогательные функции для API запросов с автоматическим добавлением токена
export const createAuthenticatedRequest = (token?: string) => ({
  get: (url: string, config: any = {}) =>
    apiClient.get(getApiUrl(url), {
      ...config,
      headers: {
        ...(config.headers || {}),
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    }),

  post: (url: string, data?: any, config: any = {}) =>
    apiClient.post(getApiUrl(url), data, {
      ...config,
      headers: {
        ...(config.headers || {}),
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    }),

  put: (url: string, data?: any, config: any = {}) =>
    apiClient.put(getApiUrl(url), data, {
      ...config,
      headers: {
        ...(config.headers || {}),
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    }),

  patch: (url: string, data?: any, config: any = {}) =>
    apiClient.patch(getApiUrl(url), data, {
      ...config,
      headers: {
        ...(config.headers || {}),
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    }),

  delete: (url: string, config: any = {}) =>
    apiClient.delete(getApiUrl(url), {
      ...config,
      headers: {
        ...(config.headers || {}),
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    }),
});

// Основной экспорт для использования в хуках
export { apiClient };
export default apiClient;
